import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import FormItem from '@/common/FormItem';

import { Form, Select } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

import React, { useState } from 'react';

import styles from './index.module.less';

function HoldModal({
  modalVisible,
  setModalVisible,
  onFinish,
  loading,
  hold_reasons
}) {
  const [form] = Form.useForm();
  const { Option } = Select;
  const [selectedHoldReason, setSelectedHoldReason] = useState(null);
  /* const dispatch = useDispatch(); */

  /* const handleReject = (envelope_id) => {
    const payload = { envelope_id: envelope_id, is_approved: true };
    dispatch(rejectEnvelope(payload)).then((response) => {
     
      if (response?.payload?.success === true) {
        history.push('/app/recomm-vcc');
      }
    });
  }; */
  const data = hold_reasons;
  // [
  //   { id: 1, name: 'Awaiting Additional Information' },
  //   { id: 2, name: 'Pending Supporting Documents' },
  //   { id: 3, name: 'Requires Further Discussion or Clarification' },
  //   { id: 4, name: 'Waiting for Other Approvals' },
  //   { id: 5, name: 'Deferred Due to Timeline or Budget Review' },
  //   { id: 6, name: 'Other' }
  // ];

  const handleHoldReasonChange = (value) => {
    setSelectedHoldReason(value);
  };

  return (
    <CustomModal
      visible={modalVisible === 'hold' ? true : false}
      className={styles.background}
      title={'On Hold'}
      onCancel={() => setModalVisible('')}
      /*  width={'45%'} */
      footer={null}
    >
      <div className="">
        <Form
          form={form}
          layout="vertical"
          className="ant-form ant-form-vertical"
          onFinish={onFinish}
        >
          <FormItem
            label="Select reason for hold"
            name="hold_reason"
            rules={[
              {
                required: true,
                message: 'Required field'
              }
            ]}
          >
            <Select
              style={{ width: '100%' }}
              // options={data}
              autoFocus
              showIcon={false}
              filterOption={true}
              onChange={handleHoldReasonChange}
              placeholder="Select reason"
              // onSelect={handleReviewerSelect}
              // {/* Map through your data array to generate options */}
            >
              {data.map((reviewer) => (
                <Option key={reviewer.id} value={reviewer.name}>
                  {reviewer.name}
                </Option>
              ))}
            </Select>
          </FormItem>

          {selectedHoldReason == 'Other' && (
            <FormItem
              label="Comments"
              name="comments"
              rules={[
                {
                  required: true,
                  // required: selectedHoldReason === 'Other', // Only required if "Other" is selected
                  message: 'Please enter comments'
                }
              ]}
            >
              <TextArea
                style={{ width: '100%' }}
                placeholder="Add your reason for on Hold"
                rows={4}
                allowClear
                // disabled={selectedHoldReason !== 'Other'} // Disable if not "Other"
              />
            </FormItem>
          )}

          <FormItem className="mb-1 text-right">
            <CustomButton
              className="mr-2"
              htmlType="button"
              onClick={() => setModalVisible('')}
            >
              Cancel
            </CustomButton>
            <CustomButton type="primary" htmlType="submit" loading={loading}>
              On Hold
            </CustomButton>
          </FormItem>
        </Form>
      </div>
    </CustomModal>
  );
}

export default HoldModal;
